import React, { useEffect, useState } from "react";
import Select from "react-select";
import { productsService } from "../../api/products.service";

const Step1 = ({
	selected,
	handleStep1Change,
	setIsOpenModels,
	setCredits,
	setOriginalCredits,
	setIdProduct,
	credits,
	originalCredits,
	horse,
	onContinue,
	canContinue,
}) => {
	const [loadError, setLoadError] = useState(false);

	const modelOptions = [
		{ value: "1", label: "Global Models" },
		{ value: "2", label: "Australian/New Zealand Models" },
	];

	const selectedModelValue = String(selected.ml_model || modelOptions[0].value);
	const currentModel =
		modelOptions.find((opt) => opt.value === selectedModelValue) ||
		modelOptions[0];

	const handleInputChange = (e) => {
		handleStep1Change({ [e.target.id]: e.target.value });
	};

	const handleSelectChange = (option) => {
		handleStep1Change({ ml_model: option.value });
	};

	useEffect(() => {
		if (horse?.sponsor) {
			setCredits(0);
		} else {
			setCredits(originalCredits);
		}
	}, [horse, originalCredits, setCredits]);

	useEffect(() => {
		console.info("[sponsor] Step1 model state", {
			selectedMlModel: selected.ml_model,
			currentModelValue: currentModel?.value,
			currentModelLabel: currentModel?.label,
		});
	}, [currentModel, selected.ml_model]);

	useEffect(() => {
		let cancelled = false;

		const fetchWithRetry = async (retries = 3, delay = 1000) => {
			try {
				const response = await productsService.list("basic", retries);
				if (cancelled) return;

				const basicProduct = response.results.find(
					(p) => p.product_type === "basic"
				);
				if (basicProduct) {
					setCredits(basicProduct.amount);
					setOriginalCredits(basicProduct.amount);
					setIdProduct(basicProduct.id);
				}

				setLoadError(false);
			} catch (err) {
				if (!cancelled) {
					console.error(
						"Error fetching products after retries:",
						err
					);
					setLoadError(true);
				}
			}
		};

		fetchWithRetry();

		return () => {
			cancelled = true;
		};
	}, [setCredits, setOriginalCredits, setIdProduct]);

	return (
		<div className="component-card pedigree-step-card">
			{loadError && (
				<div className="error-message" role="alert">
					Unexpected error loading product info. Please try reloading
					the page.
				</div>
			)}

			<div className="credits-indicator" aria-label={`${credits} credits required`}>
				<i className="fa fa-coins cursor ml-5 mr-10" />
				<p className="credits-text is-black">
					<span className="light-bold price">{credits}</span> credits
				</p>
			</div>

			<div className="pedigree-step-card__content">
				<h2 className="subtitle is-black mb-5">Report details</h2>
				<p className="pedigree-step-help mb-20">
					Give the report a memorable name and choose the model that best
					matches the horses you are analysing.
				</p>

				<div className="pedigree-details-grid">
					<div className="input-container">
						<label className="input-field__label is-black mb-5" htmlFor="name">
							Report name
						</label>
						<input
							type="text"
							className="input-text"
							placeholder="e.g. Spring mating analysis"
							id="name"
							value={selected.name || ""}
							onChange={handleInputChange}
							data-tour-id="pedigree-name-input"
							autoComplete="off"
							aria-describedby="pedigree-name-help"
						/>
						<span id="pedigree-name-help" className="field-help">
							This name will appear in your report history.
						</span>
					</div>

					<div className="input-container">
						<label className="input-field__label is-black mb-5" htmlFor="pedigree-model">
							Model
						</label>
						<div className="model-select-row">
							<Select
								inputId="pedigree-model"
								options={modelOptions}
								value={currentModel}
								onChange={handleSelectChange}
								className="react-select-container"
								classNamePrefix="react-select"
								isClearable={false}
							/>
							<button
								type="button"
								className="pedigree-icon-button"
								onClick={() => setIsOpenModels(true)}
								aria-label="Learn about pedigree models"
								title="Learn about pedigree models"
							>
								<i className="fas fa-question-circle" aria-hidden="true" />
							</button>
						</div>
						<span className="field-help">
							{selectedModelValue === "2"
								? "Best for Australian and New Zealand bloodlines."
								: "Best for international bloodlines and general analysis."}
						</span>
					</div>
				</div>

				<div className="pedigree-step-actions pedigree-step-actions--end">
					<button
						type="button"
						className="button"
						onClick={onContinue}
						disabled={!canContinue}
						data-tour-id="pedigree-details-continue"
					>
						{canContinue ? "Continue to parents" : "Add a report name"}
						<i className="fas fa-arrow-right ml-10" aria-hidden="true" />
					</button>
				</div>
			</div>
		</div>
	);
};

export default Step1;
